<template>
  <div class="container">
    <h1 class="mt-2 mb-4 font-sans-bold">{{ event.title }}</h1>
    <p class="mb-4">
      <strong>Status:</strong>
      <span v-if="event.published">Published</span>
      <span v-else>
            <template v-if="event.status === 'new'">Draft</template>
            <template v-if="event.status === 'needs review'">In Review</template>
        </span>
    </p>
    <p class="mb-4">
      <strong>Festival:</strong> {{ (event.festival) ? event.festival.title : '' }}
    </p>
    <p class="mb-4">
      <strong>Start date:</strong> {{ event.start_at | moment("MMM Do YYYY, h:mm a") }}
    </p>
    <p class="mb-4">
      <strong>End date:</strong> {{ event.end_at | moment("MMM Do YYYY, h:mm a") }}
    </p>
    <p class="mb-4">
      <button class="bg-blue text-white rounded-sm p-2" @click.stop.prevent="editEvent">Edit Event</button>
    </p>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "EventDetail",
  title: "Event Detail",
  props: {},
  data: () => ({}),
  computed: {
    ...mapGetters({
      event: "event"
    })
  },
  methods: {
    editEvent() {
      this.$router.push({
        name: "events-basics",
        params: {id: this.event.id}
      });
    }
  },
  mounted() {
  }
};
</script>
